export const API_URL = 'https://compass-wsq.ucop.edu/CustomerSiteWS2-0.0.1-SNAPSHOT/services';

export const DEFAULT_CALENDAR_TYPE = 'S';

export const DEFAULT_CALENDAR_YEAR = '2024-2025';